import { Container, Row, Col } from 'react-bootstrap';
import { litrals } from '../../../../../../../constants/Litrals';

const AvailableFeeds = () => {
  return (
    <Container className="subscriber-container">
      <Row className="justify-content-center">
        <Col xs={12} md={8}>
          <h3 data-testid="available-feeds">
            {litrals.subscriberAvailableFeeds}
          </h3>
          <div className="subscriber-content">
            <h6>Test Payload and Schema for:</h6>
            <ol>
              <li> Predicted Traffic Data</li>
              <li>Network Model Data</li>
              <li>TMU Loop Traffic Data</li>
              <li>MIDAS Loop Traffic Data</li>
              <li>VSS Data</li>
              <li>Fused Traffic Data</li>
              <li>Asset Data</li>
              <li>Event Data</li>
            </ol>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default AvailableFeeds;
